import MixPanelProvider, { useMixpanel } from './MixPanelProvider';

export default MixPanelProvider;
export { useMixpanel };
